export default {
    'About Us':'About Us',
    'Productions':'Productions',
    'Theatres':'Theatres',
    'Contact Us':'Contact Us',
    'Welcome to ACOrange':'Welcome to ACOrange',
    'ACOrange is the largest private performance enterprise in China.': 'ACOrange is the largest private performance enterprise in China.',
    'We apply strategic planning to cover all segments of perfomance industry.':'We apply strategic planning to cover all segments of perfomance industry.',
    'Our content covers all performance genres.':'Our content covers all performance genres.',
    'Top-rank market share of Family Show, Pop Music Live Concert, Musical and many other sectors':'Top-rank market share of Family Show, Pop Music Live Concert, Musical and many other sectors',
    'We are the first Chinese Corporation investing in Broadway musicals.':'We are the first Chinese Corporation investing in Broadway musicals.',
    'Production & Presentation':'Production & Presentation',
    'CATS':'CATS',
    'WESTLIFE THE TWENTY TOUR':'WESTLIFE THE TWENTY TOUR',
    'CIRQUE DU SOLEIL OVO':'CIRQUE DU SOLEIL OVO',
    'HYDE WORLD TOUR 2019 ...':'HYDE WORLD TOUR 2019 ...',
    'Urban Drama Festival':'Urban Drama Festival',
    'Read More':'Read More',
    'Nanshan Cultural and Sports Center':'Nanshan Cultural and Sports Center',
    'Shijiazhuang Grand Theatre':'Shijiazhuang Grand Theatre',
    'Putuo Grand Theatre':'Putuo Grand Theatre',
    'Tianyuan Arts Centre of...':'Tianyuan Arts Centre of...',
    'Yinshanhu Grand Theatre of Suzhou':'Yinshanhu Grand Theatre of Suzhou',
    'China':'China',
    "Shenzhen":"Shenzhen",
    "Shijiazhuang":"Shijiazhuang",
    "Zhoushan":"Zhoushan",
    "Nanping":"Nanping",
    "Suzhou":"Suzhou",


}